import React from 'react'
import FileUpload from '../FileUpload'
import Button from 'shared/components/Button'

function JSONEditor({ json, value, onChange, onDelete, label = 'Upload physical json' }) {

  return (
    <div className="w-full">
      {' '}
      <div className="text-sm my-[16px] opacity-50">{label}</div>
      <div className="bg-[#F5F5F5] w-full rounded-[10px] p-[16px]">
        <div className="flex justify-between items-center overflow-x-auto">
          <FileUpload
            accept=".json,application/json"
            label={label}
            onChange={(file) => {
              if (!file) {
                onChange(null)
                return
              }
              const reader = new FileReader()
              reader.onload = (e) => {
                try {
                  const jsonData = JSON.parse(e.target.result)
                  onChange(jsonData)
                } catch (error) {
                  console.error('Failed to parse JSON file:', error)
                }
              }
              reader.readAsText(file)
            }}
          />
          {json && !value && (
            <Button variant="secondary" size="small" rounded onClick={onDelete}>
              Delete JSON
            </Button>
          )}
        </div>
        {(value || json) && (
          <div className="mt-[16px]">
            <pre className="bg-[#cacaca] text-sm text-black rounded-[8px] p-[16px] max-h-[200px] overflow-y-auto">
              {JSON.stringify(value || json, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </div>
  )
}

export default JSONEditor
